import React, { useEffect, useState } from 'react'
import { map } from 'lodash'
import SectionSponsorsApi from '../../../api/sections/SponsorsApi'
import Sponsor from './Sponsor.js'

const Sponsors = ({ section }) => {
  const [sponsors, setSponsors] = useState([])

  useEffect(() => {
    if (!section?.id) return
    SectionSponsorsApi.getAll(section.id).then((res) => {
      if (res.response?.ok) {
        setSponsors(res.json)
      }
    })
  }, [section?.id])

  return (
    <div className='row center-xs'>
      {map(sponsors, (sponsor) => (
        <Sponsor key={sponsor.id} {...sponsor} size={section.size} />
      ))}
    </div>
  )
}

export default Sponsors
